import { GraphQLClient } from 'graphql-request';

import { getGraphqlEndpointByService } from 'utils/api.utils';

export const datoClient = (
  { preview }: { preview?: boolean } = { preview: false },
  token?: string,
) => {
  const url = getGraphqlEndpointByService('dato');
  return new GraphQLClient(url, {
    headers: {
      Authorization: `Bearer ${token ?? process.env.NEXT_PUBLIC_DATOCMS_FRONTEND_TOKEN}`,
      'X-Exclude-Invalid': 'true',
      ...(process.env.NEXT_PUBLIC_DATO_ENV
        ? { 'X-Environment': process.env.NEXT_PUBLIC_DATO_ENV }
        : {}),
      ...(preview ? { 'X-Include-Drafts': 'true' } : {}),
    },
  });
};
